import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'consultoria-nutricional-inicial',
    title: 'Consultoria nutricional inicial',
    description: 'Colete o histórico alimentar, objetivos e restrições dos seus clientes antes da primeira consulta.',
    indicatedFor: 'Nutricionistas',
    stepsCount: 2,
    questionsSummary: ['Objetivo nutricional', 'Restrições alimentares', 'Histórico de saúde', 'Rotina atual'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Consultoria nutricional inicial',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Seus objetivos',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Qual é o seu nome completo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Qual é o seu principal objetivo com a consultoria nutricional?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'choices',
                        label: 'Você possui alguma restrição alimentar?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Nenhuma' },
                                { id: 'opt-2', label: 'Intolerância à lactose' },
                                { id: 'opt-3', label: 'Intolerância ao glúten' },
                                { id: 'opt-4', label: 'Vegetariano / Vegano' },
                                { id: 'opt-5', label: 'Alergia alimentar' },
                                { id: 'opt-6', label: 'Outra' },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: 'Saúde e histórico',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: 'Você possui alguma condição de saúde diagnosticada (diabetes, hipertensão, etc.)?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Descreva brevemente sua rotina alimentar atual.',
                        description: 'Ex: número de refeições por dia, horários, alimentos mais consumidos.',
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'weight',
                        label: 'Qual é o seu peso atual?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
